<template>
    <div class="section px-0 py-5" :class="{'px-5':noProjectsToShow}">
        <transition-group
            name="lb-project-list"
            tag="div"
            class="columns is-multiline is-mobile mx-0"
            appear
        >
            <router-link
                v-if="showCreationCard"
                :key="'creationCard'"
                class="
                    column
                    is-12-mobile is-6-tablet is-4-desktop is-3-widescreen
                    lb-project-card lb-creation-object
                "
                :to="{
                    path: '/creation',
                    query: {
                        folder: this.$route.params.folder,
                    },
                }"
            >
                <div class="lb-project-box has-background-info-light">
                    <div
                        class="
                            columns
                            is-multiline is-mobile is-marginless
                            has-background-info-light
                        "
                    >
                        <div
                            class="
                                column
                                is-full
                                has-text-centered
                                has-text-weight-bold
                                has-text-primary
                            "
                        >
                            <span class="icon is-large">
                                <i
                                    class="
                                        mdi mdi-10r mdi-plus-circle-outline
                                        pt-5
                                    "
                                    aria-hidden="true"
                                />
                            </span>
                        </div>
                        <div
                            class="
                                column
                                is-full
                                has-text-centered has-text-weight-bold
                            "
                        >
                            <p
                                class="
                                    is-size-5
                                    lb-card-title
                                    is-block
                                    has-text-primary
                                "
                            >
                                {{ $t('creation.new_project') }}
                            </p>
                        </div>
                    </div>
                </div>
            </router-link>

            <div
                v-for="project in projects"
                :key="project._id"
                :to="{ name: 'project', params: { projectId: project._id } }"
                tag="div"
                draggable="true"
                class="column is-12-mobile is-6-tablet is-4-desktop is-3-widescreen lb-project-card"
                @dragstart="dragStart($event, project)"
                @dragenter.prevent
                @dragover.prevent
                @click="selectProject(project)"
            >
                <project-card
                    :content="project"
                    @delete="deleteProject(project)"
                    @removeFromFolder="removeProjectFromFolder(project)"
                    @clone="clone(project)"
                    @show-share-modal="openShareModal(project)"
                    @view="viewProject(project)"
                    @highlight="toggleHighlight(project)"
                    @unhighlight="toggleHighlight(project)"
                />
            </div>
        </transition-group>
        <duplicate-project-modal
            v-if="showDuplicateModal"
            :project="project"
            @close="showDuplicateModal = false"
            @add-project="addProject"
        ></duplicate-project-modal>

        <project-modal-share
            v-if="showShareModal"
            :content="project"
            :library="library"
            :showViewButton="canView(project)"
            @close="showShareModal = false"
            @view="viewProject(project)"
            class="project-resume"
        ></project-modal-share>
    </div>
</template>

<script>
import ProjectCard from '@/components/ProjectCard';
import ProjectModalShare from '@/components/ProjectModalShare';
import DuplicateProjectModal from '@/components/DuplicateProjectModal';
import { deleteItem, removeProjectFromFolder, highlightProject } from '@/services/API';
import _ from 'underscore';
import Swal from 'sweetalert2';
export default {
    components: {
        ProjectCard,
        DuplicateProjectModal,
        ProjectModalShare,
    },
    props: {
        projects: {
            type: Array,
            default() {
                return [];
            },
        },
        showCreationCard: {
            type: Boolean,
            default: false,
        },
        library: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showModal: false,
            showShareModal: false,
            project: null,
            showDuplicateModal: false,
        };
    },
    computed: {
        noProjectsToShow(){
            return this.showCreationCard && !this.projects.length && !this.$route.params.folder;
        }
    },
    mounted() {
        // console.log("show creation card?", this.showCreationCard)

        // console.log("active plan", this.$store.getters.activePlan)
        // console.log("projects",this.projects)
        
    },
    methods: {
        isGame(project){
            if(project.format == 'PROJECT_TYPE_QUIZ' || project.format == 'PROJECT_TYPE_GEOQUIZ' || project.format == 'PROJECT_TYPE_QUIZHUNT' || project.format == 'PROJECT_TYPE_TREASUREHUNT'){
                return true;
            }else if(project.type=='trivial' || project.type=="treasurehunt"){
                return true;
            }
            return false;

        },
        selectProject(project) {
            /*this.showModal = true;
            this.project = project;*/
            this.project = project;
            if(this.library || !this.canAccessProject(project)){
                /*if(this.isGame(project)){
                    this.openShareModal(project);
                }else{
                    if (this.project.mode && this.project.mode == 'map') {
                        this.$router.push({
                            name: 'project-view',
                            params: { projectId: this.project._id },
                        });
                    } else {
                        this.$router.push({
                            name: 'project',
                            params: { projectId: this.project._id },
                        });
                    }
                }*/
                this.openShareModal(project);
            }else if (this.canAccessProject(project)) {
                this.$router.push({
                    name: 'project',
                    params: { projectId: this.project._id },
                });
            } else {
                /*if(this.isGame(project)){
                    this.openShareModal(project);
                }else{
                    if (this.project.mode && this.project.mode == 'map') {
                        this.$router.push({
                            name: 'project-view',
                            params: { projectId: this.project._id },
                        });
                    } else {
                        this.$router.push({
                            name: 'project',
                            params: { projectId: this.project._id },
                        });
                    }
                }*/
                
            }
        },
        canAccessProject(project){
            if(this.$store.getters.isLoggedIn && 
            !this.$store.getters.isAnonymous && 
            ((this.project.accessLevel && project.accessLevel != 'read') || project.defaultPermission!='read')
            ){
                return true;
            }else if((this.$store.getters.isAnonymous || !this.$store.getters.isLoggedIn) && project.allowAnonymous==true){
                return true;
            }
            return false;
        },
        canView(project){
            if(project.accessLevel == 'administrator'){
                return true;
            }
            if(project.format == 'PROJECT_TYPE_QUIZ' || project.format == 'PROJECT_TYPE_GEOQUIZ' || project.format == 'PROJECT_TYPE_QUIZHUNT'){
                return false;
            }else if(project.type=='trivial'){
                return false;
            }else if((project.format == 'PROJECT_TYPE_TREASUREHUNT' || project.type=='treasurehunt') && project.privacy != 'public' ){
                return false;
            }
            return true;
        },
        viewProject(project) {
            this.project = project;
            /*if (this.project.mode && this.project.mode == 'map') {
                this.$router.push({
                    name: 'project-view',
                    params: { projectId: this.project._id },
                });
            } else {*/
                this.$router.push({
                    name: 'project',
                    params: { projectId: this.project._id },
                });
           // }
        },
        async deleteProject(item) {

            Swal.fire({
                title: this.$t('delete_project_title') + " " + item.title,
                text: this.$t('delete_project_confirmation_message'),
                showCancelButton: true,
                confirmButtonText: this.$t('dropdown_option_delete_object'),
                cancelButtonText: this.$t('userProfile.leave_school_cancel'),
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deleteProjectAction(item);
                }
            });
        },
        async deleteProjectAction(item){
            let response = await deleteItem('project', item._id);
            if (response.data.success) {
                this.$emit('deleteProject', item._id);
            } else {
                console.error('impossible to delete project');
            }
        },
        async removeProjectFromFolder(project) {
            const projectIndex = _.findIndex(this.projects, {
                _id: project._id,
            });
            const splicedProject = this.projects.splice(projectIndex, 1);
            removeProjectFromFolder(project.folder._id, {
                project: project._id,
            }).catch(() => {
                this.projects.splice(projectIndex, 0, splicedProject[0]);
            });
        },
        dragStart(ev, project) {
            ev.dataTransfer.setData('project', project._id);
        },
        clone(project) {
            // console.log("try to clone ",project);
            this.project = project;
            this.showDuplicateModal = true;
        },
        addProject() {
            // console.log('projectsgrid');
            //this.projects.push(projectData);
            this.$emit('addProject');
        },
        openShareModal(project) {
            this.project = project;
            this.showShareModal = true;
        },
        async toggleHighlight(project) {
            let featuredResult = await highlightProject(project._id);
            //this.project = featuredResult.data;
            this.$emit("toggleHighlight",featuredResult.data)
        }
    },
};
</script>

<style scoped>
@import '../assets/css/swal-eduloc.css';
.lb-creation-object .icon.is-large {
    height: 10rem;
    width: 10rem;
}
.mdi-10r {
    font-size: 10rem;
}
</style>
